export default __webpack_public_path__ + "static/media/8.9928b311.png";